import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28e99171"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "history-trace" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "历史记录", -1))
const _hoisted_4 = { class: "main" }
const _hoisted_5 = { id: "traceability-table" }
const _hoisted_6 = { class: "op" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-delete" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 删除 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TabPane = _resolveComponent("TabPane")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Popconfirm = _resolveComponent("Popconfirm")!
  const _component_Table = _resolveComponent("Table")!
  const _component_ConfigProvider = _resolveComponent("ConfigProvider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: "back",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/logged/analysis/traceability')))
      }, "返回")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Tabs, {
        activeKey: _ctx.activeTab,
        "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeTab) = $event)),
        type: "card"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPane, {
            key: "1",
            tab: "手动点"
          }),
          _createVNode(_component_TabPane, {
            key: "0",
            tab: "默认点"
          })
        ]),
        _: 1
      }, 8, ["activeKey"]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_ConfigProvider, { locale: _ctx.zhCN }, {
          default: _withCtx(() => [
            _createVNode(_component_Table, {
              "data-source": _ctx.tableData,
              columns: _ctx.columns,
              scroll: {y: '5.6rem'},
              pagination: {
            total: _ctx.total,
            pageSize: 10,
            size: 'small',
            current: _ctx.current,
            showQuickJumper: true,
            showTotal: (total) => `共 ${total} 条`,
            onChange: (page, pageSize) => _ctx.handleChange(page, pageSize),
          }
            }, {
              index: _withCtx(({ index, }) => [
                _createElementVNode("span", null, _toDisplayString(index + 1), 1)
              ]),
              time: _withCtx(({ text, }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.moment(text).format('YYYY-MM-DD HH:mm')), 1)
              ]),
              pointType: _withCtx(({ text, }) => [
                _createElementVNode("span", null, _toDisplayString(text === 0 ? '是' : '否'), 1)
              ]),
              runStatus: _withCtx(({ text, }) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: _ctx.runStatus[text].color })
                }, _toDisplayString(_ctx.runStatus[text].text), 5)
              ]),
              op: _withCtx(({ record, }) => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_Button, {
                    style: _normalizeStyle({ cursor: record.runStatus !== 1 ? 'not-allowed': 'pointer', color: record.runStatus === 1 ? '#46AC70' : '#999', backgroundColor: 'transparent', border: 'none', paddingLeft: 0}),
                    disabled: record.runStatus !== 1,
                    onClick: ($event: any) => (_ctx.showTrace(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 2
                  }, 1032, ["style", "disabled", "onClick"]),
                  _createVNode(_component_Popconfirm, {
                    overlayClassName: "delete-pop",
                    title: "是否删除?",
                    "ok-text": "确定",
                    "cancel-text": "取消",
                    onConfirm: ($event: any) => (_ctx.deleteConfirm(record)),
                    disabled: record.runStatus !== 1
                  }, {
                    icon: _withCtx(() => [
                      _hoisted_8
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_Button, {
                        style: _normalizeStyle({ color: record.runStatus === 1 ? '#F77B59' : '#999', backgroundColor: 'transparent', border: 'none'}),
                        disabled: record.runStatus !== 1
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 2
                      }, 1032, ["style", "disabled"])
                    ]),
                    _: 2
                  }, 1032, ["onConfirm", "disabled"])
                ])
              ]),
              _: 1
            }, 8, ["data-source", "columns", "scroll", "pagination"])
          ]),
          _: 1
        }, 8, ["locale"])
      ])
    ])
  ]))
}